module.exports = __webpack_public_path__ + "static/media/repeat.52586c7f.svg";